import { createContext } from 'react'

const LayoutContext = createContext({})
export const LayoutProvider = LayoutContext.Provider
export const LayoutConsumer = LayoutContext.Consumer


// WEBPACK FOOTER //
// ./src/features/common/redux/context.js